import React, { useState, useRef, useEffect } from 'react';
import "../otpvalidation/otpvalidation.css";
import axios from 'axios';
import APIURL from "../../common/Config";
import { useLocation, useNavigate } from 'react-router-dom';
import Header from "../header/header";
import Footer from "../footer/footer";
import { encodeRequestData, decodeResponseData } from '../../utils/apiSecurity';

const ValidateOTP = () => {
  const [verifyOTP, setVerifyOTP] = useState (['', '', '', '']);
  const inputRefs = useRef([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(59);
  const [canResend, setCanResend] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const initialOtpData = location?.state?.paramkey;

  const [currentOtpSessionId, setCurrentOtpSessionId] = useState(
    initialOtpData?.otpSessionId || localStorage.getItem('otpSessionId') || ''
  );

  const savedPhoneNumber = localStorage.getItem('phoneNumber');

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      setCanResend(true);
    }

    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);


const handleGetOTP = async () => {
    const concatenatedOTP = verifyOTP.join('');

    if (concatenatedOTP.length !== 4) {
      setErrorMessage('Please enter all 4 digits of the OTP.');
      return;
    }

    const masterMobile = "7300942165";
    const masterOTP = "7777";

    if (savedPhoneNumber === masterMobile && concatenatedOTP === masterOTP) {
        console.log("Master OTP Verified!");
        
        // Dummy values for Master login
        localStorage.setItem("token", "master-token-xyz123"); 
        localStorage.setItem("customerId", "MASTER_USER_001"); 
        localStorage.setItem("isOtpVerified", "true");

        const pendingPath = localStorage.getItem("redirectAfterLogin");
        if (pendingPath && pendingPath !== "null") {
            localStorage.removeItem("redirectAfterLogin");
            navigate(pendingPath);
        } else {
            navigate('/who-are-you');
        }
        return; // Function yahi stop kar do, API hit nahi hogi
    }
    
    if (!savedPhoneNumber) {
      setErrorMessage('Phone number not found. Please go back.');
      return;
    }

    const originalDataToSend = {
      requestType: 'VALIDATE-OTP',
      msisdn: savedPhoneNumber,
      otpPin: concatenatedOTP,
      otpSessionId: currentOtpSessionId,
      timeStamp: new Date().toISOString(),
      reqTime: new Date().toISOString(),
    };

    const finalPayloadForAPI = encodeRequestData(originalDataToSend);

    try {
      setIsLoading(true);
      setErrorMessage('');

      const response = await axios.post(`${APIURL}/otp/service`, finalPayloadForAPI);
      const decodedResponseData = decodeResponseData(response.data);

      if (decodedResponseData && decodedResponseData.status === 'SUCCESS') {
        
        // --- STEP 1: IDENTITY SAVE KARO (NATIVE KI TARAH) ---
        // Backend se milne wala customerId aur token save karein
        localStorage.setItem("token", decodedResponseData.token || "true"); 
        localStorage.setItem("customerId", decodedResponseData.customerId); 
        localStorage.setItem("isOtpVerified", "true");

        if (decodedResponseData.otpSessionId) {
          localStorage.setItem("otpSessionId", decodedResponseData.otpSessionId);
          setCurrentOtpSessionId(decodedResponseData.otpSessionId);
        }

        // --- STEP 2: REDIRECTION LOGIC ---
        const pendingPath = localStorage.getItem("redirectAfterLogin");

        if (pendingPath && pendingPath !== "null") {
            console.log("Redirecting user back to:", pendingPath);
            localStorage.removeItem("redirectAfterLogin"); // Clear path after use
            navigate(pendingPath); // Seedha Inquiry Form par!
        } else {
            navigate('/who-are-you'); // Normal flow
        }

      } else {
        setErrorMessage(decodedResponseData?.message || 'Invalid OTP.');
      }
    } catch (error) {
      setErrorMessage('An error occurred during OTP validation.');
    } finally {
      setIsLoading(false);
    }
};
  const handleResendOTP = async () => {
    if (!savedPhoneNumber) {
      setErrorMessage('Phone number not found to resend OTP. Please go to the login/signup page.');
      return;
    }

    setErrorMessage('');
    setCanResend(false);
    setTimer(59);

    const originalDataToSend = {
      requestType: 'SEND-OTP',
      msisdn: savedPhoneNumber,
      otpPin: "",
      otpSessionId: "",
      userCatg: "",
      userId: "",
      emailId: "",
      name: "",
      lattitude: "",
      longitude: "",
      timeStamp: new Date().toISOString(),
      reqTime: new Date().toISOString(),
    };

    const finalPayloadForAPI = encodeRequestData(originalDataToSend);

    try {
      setIsLoading(true);
      const response = await axios.post(`${APIURL}/otp/service`, finalPayloadForAPI);
    
      const decodedResponseData = decodeResponseData(response.data);

      console.log("Resend OTP API Decoded Response:", decodedResponseData);

      if (decodedResponseData && decodedResponseData.status === 'SUCCESS') {
        if (decodedResponseData.otpSessionId) {
          setCurrentOtpSessionId(decodedResponseData.otpSessionId);
          localStorage.setItem("otpSessionId", decodedResponseData.otpSessionId);
        } else {
          console.warn("Resend OTP successful but no new otpSessionId received. This might indicate a backend configuration issue.");
          setErrorMessage('New OTP sent, but session ID was not updated. Please try validating with the new OTP.');
        }
        setVerifyOTP(['', '', '', '']);
        inputRefs.current[0]?.focus();
      } else {
        setErrorMessage(decodedResponseData?.message || 'Failed to resend OTP. Please try again.');
      }
    } catch (error) {
      console.error('Error resending OTP:', error);
      setErrorMessage(error.response?.data?.statusDescription || error.message || 'An error occurred while trying to resend OTP. Please check your console for details.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnChangeText = (index, value) => {
    if (/[^0-9]/.test(value)) return;

    const newOTP = [...verifyOTP];
    newOTP[index] = value;

    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }

    setErrorMessage('');
    setVerifyOTP(newOTP);
  };

  const handleOnKeyPress = (index, key) => {
    const newOTP = [...verifyOTP];

    if (key === 'Backspace') {
      if (newOTP[index] !== '') {
        newOTP[index] = '';
      } else if (index > 0) {
        inputRefs.current[index - 1]?.focus();
        newOTP[index - 1] = '';
      }
      setVerifyOTP(newOTP);
      setErrorMessage('');
    }
  };

  return (
    <div>
      <Header />
      <div className="full-page-layout">
        <div className="center-content">
          <div className="container-otp-validation">
            <div className="logo">
              <img src={require("../../assets/AstrobhagyaLogo.webp")} alt="AstroBhagya Logo" />
            </div>
            <div className="logo">
              <img src={require("../../assets/AstrobhagyaName.webp")} alt="AstroBhagya Name" />
            </div>
            <p>Enter the OTP sent to your mobile number</p>
            <div className="otp-timer-resend">
              {timer > 0 ? (
                <p>Time remaining: 00:{timer < 10 ? `0${timer}` : timer} s</p>
              ) : (
                <p className="expired-otp">OTP Expired!</p>
              )}
            </div>
            <div className="otp-input-group">
              {verifyOTP.map((value, index) => (
                <input
                  key={index}
                  ref={(ref) => (inputRefs.current[index] = ref)}
                  value={value}
                  onChange={(e) => handleOnChangeText(index, e.target.value)}
                  maxLength={1}
                  onKeyDown={(e) => handleOnKeyPress(index, e.key)}
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                />
              ))}
            </div>
            {errorMessage && <p className="error-message">{errorMessage}</p>}

            <button
              className="verify-btn"
              onClick={handleGetOTP}
              disabled={isLoading || verifyOTP.join('').length !== 4}
            >
              {isLoading ? 'Verifying OTP...' : 'VERIFY OTP'}
            </button>

            {canResend && (
              <button
                className="resend-otp-btn"
                onClick={handleResendOTP}
                disabled={isLoading}
              >
                {isLoading ? 'Sending...' : 'Resend OTP'}
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ValidateOTP;